import { css } from '@emotion/react';

export const styles = {
  box: css`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #212121;
  `,
  card: css`
    width: 90%;
    max-width: 400px;
    background-color: #424242;
    color: #e0e0e0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    border: 1px solid #616161;
    padding: 32px;
  `,
  header: css`
    font-size: 2.125rem;
    font-weight: 600;
    text-align: center;
    color: #BDBDBD;
    margin-bottom: 16px;
  `,
  input: css`
    & .MuiOutlinedInput-root {
      background-color: #0C1018;
      color: #e0e0e0;
      & fieldset {
        border-color: #757575;
      }
      &:hover fieldset {
        border-color: #9e9e9e;
      }
      &.Mui-focused fieldset {
        border-color: #1976d2;
      }
    }
    & .MuiInputLabel-root {
      color: #bdbdbd;
    }
    & .MuiInputLabel-root.Mui-focused {
      color: #1976d2;
    }
  `
};